
import { useNavigate, useParams } from "react-router-dom"
import React, { useState, useEffect } from 'react'
import api from "../../../../services/api";
import { useSelector } from 'react-redux';
import Date from "../../../../utils/date";
import HeaderSession from "../../../../utils/headerSession";
import TextoFormatado from "../../../../utils/textoFormatado";
import ResponseExpediente from "./responseExpediente";
import CreateObservacaoExpediente from "./createObservacaoExpediente";
import NavLateral from "./navLateral";
import PreviewAnexos from "../../../../utils/PreviewAnexos";
import InfoFieldGroup from "../../../../utils/InfoField/InfoFieldGroup";
import DateHora from "../../../../utils/dateHora";
import ProcessoLoading from "../../../../load/processoLoading";
import QRCodeExpediente from "./qrCodeExpediente";

export default function GestExpediente({ element: component, ...rest }) {
    const baseUrl = window.location.origin;
    let { id } = useParams()
    const [expediente, setExpediente] = useState('')
    const user = useSelector(state => state.account.user);
    const [update, setUpdate] = useState(false)

    const [previewFiles, setPreviewFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);


    const handleOpenPreview = (documents, fileIndex = 0) => {
        const valid = documents.filter((d) => typeof d === "string" && d.trim() !== "");
        if (!valid.length) return;
        setPreviewFiles(valid);
        setCurrentFileIndex(fileIndex);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => setPreviewOpen(false);

    const handleNavigate = (index) => {
        if (index >= 0 && index < previewFiles.length) {
            setCurrentFileIndex(index);
        }
    };

    useEffect(() => {
        api.get(`/expediente/${id}`)
            .then(response => {
                // console.log(response)
           
                // if (!temPermissao(user, [response.data.expediente.status])) {
                    // dispatch({
                    //     type: "alert",
                    //     payload: { alert: "Acesso negado" },
                    // });
                    // navigate("/admin/menu");
                // }

                setExpediente(response.data.expediente);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [id, update])

    if (!expediente) {
        return <ProcessoLoading />
    }

    return (
        <div className="tw-max-w-[1300px] tw-mx-auto tw-px-4 tw-py-6">
            <HeaderSession title={'GESTÃO DE EXPEDIENTE'} />

            <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-6">
                <aside className="tw-w-full md:tw-w-[300px] md:tw-sticky md:tw-top-[70px] tw-self-start">
                    <NavLateral
                        observacoesFeitas={expediente?.observacoes}
                        expediente={expediente}
                        setUpdate={setUpdate}
                    />
                </aside>

                <main className="tw-flex-1 tw-w-full tw-z-10">
                    <section className="tw-bg-white tw-shadow-sm tw-rounded-xl tw-p-6 tw-mb-6">
                        {component && React.cloneElement(component, {
                            expediente: expediente,
                            setUpdate: setUpdate
                        })}

                        <InfoFieldGroup
                            fields={
                                [
                                    { label: 'Localização', value: expediente?.status, editable: false, },
                                    { label: 'Nome', value: expediente?.nome, key: 'nome', onChange: '(v) => setEditDados({ ...editDados, nome: v.target.value })' },
                                    { label: 'Nº Registo', value: expediente?.numero, key: 'numero', onChange: '(v) => setEditDados({ ...editDados, numero: v.target.value })' },
                                    { label: 'Portador / Remetente', value: expediente?.remetidoPor?.nome, key: 'remetidoPor', onChange: '(v) => setEditDados({ ...editDados, remetidoPor: v.target.value })' },
                                    { label: 'Tipo de Documento', value: expediente?.tipoDocumento?.designacao, key: 'tipoDocumento', onChange: '(v) => setEditDados({ ...editDados, tipoDocumento: v.target.value })' },
                                    { label: 'Tipo de Remetente', value: expediente?.tipoRemetente, key: 'tipoRemetente', onChange: '(v) => setEditDados({ ...editDados, tipoRemetente: v.target.value })' },
                                    { label: 'Nº do Documento', value: expediente?.numeroDocumento, key: 'numeroDocumento', onChange: '(v) => setEditDados({ ...editDados, numeroDocumento: v.target.value })' },
                                    { label: 'Assunto', value: expediente?.assunto, key: 'assunto', onChange: '(v) => setEditDados({ ...editDados, assunto: v.target.value })' },
                                    { label: 'Data do Documento', value: <Date date={expediente?.dataAnexo} />, key: 'dataAnexo' },
                                    { label: 'Email', value: expediente?.email, key: 'email', onChange: '(v) => setEditDados({ ...editDados, email: v.target.value })' },
                                    { label: 'Contacto', value: expediente?.tel, key: 'tel', onChange: '(v) => setEditDados({ ...editDados, tel: v.target.value })' },
                                    { label: 'Registado Por', value: expediente?.admin?.dadosPessoais?.nome, key: 'user', onChange: '(v) => setEditDados({ ...editDados, userId: v.target.value })' },
                                    { label: 'Data Registo', value: <DateHora date={expediente?.createdAt} />, key: 'createdAt' },
                                    { label: 'Ultima Intervenção', value: <DateHora date={expediente?.updatedAt} />, key: 'updatedAt' },
                                ]
                            } />
                    </section>

                    <section className="tw-bg-white tw-shadow-sm tw-rounded-xl tw-p-6 tw-mb-6">
                        <div className="tw-bg-[#f8f4ff] tw-p-6 tw-rounded-lg tw-mb-4">
                            <p className="tw-font-semibold tw-mb-2">Exposição:</p>
                            <TextoFormatado texto={expediente?.descricao ?? ''} />
                        </div>
                    </section>

                    <section className="tw-bg-white tw-shadow-sm tw-rounded-xl tw-p-6 tw-mb-6">
                        <div className="tw-mb-4 tw-text-base">
                            <p className="tw-font-semibold tw-mb-2">Documento anexado nº {expediente?.numeroDocumento}</p>
                            <a
                                href={expediente?.anexo || '#'}
                                target="_blank"
                                rel="noreferrer"
                                className="tw-text-armed-primary hover:tw-underline"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenPreview([expediente?.anexo], 0);
                                }}
                            >
                                {expediente?.anexo ? 'Anexo' : ''}
                            </a>
                        </div>
                        <div className="tw-w-full tw-h-[700px] tw-overflow-hidden tw-rounded-lg">
                            <iframe
                                id="pdfIframeExpediente"
                                title={`PDF Viewer`}
                                src={expediente?.anexo || ''}
                                className="tw-w-full tw-h-full tw-border-none"
                            />
                        </div>
                    </section>

                    <section className="tw-bg-white tw-shadow-sm tw-rounded-xl tw-p-6 tw-mb-6">
                        <CreateObservacaoExpediente
                            userId={user?._id}
                            expedienteId={id}
                            observacoes={expediente?.observacoes}
                            setUpdate={setUpdate}
                        />
                    </section>

                    <section className="tw-bg-white tw-shadow-sm tw-rounded-xl tw-p-6 tw-mb-6">
                        <ResponseExpediente
                            userId={user?._id}
                            expediente={expediente}
                            setUpdate={setUpdate}
                        />
                    </section>

                    <section className="tw-bg-white tw-shadow-sm tw-rounded-xl tw-p-6">
                        <QRCodeExpediente header={true} link={`${baseUrl}/admin/expediente/view/${id}`} expediente={expediente} />
                    </section>
                </main>
            </div>

            <PreviewAnexos
                files={previewFiles}
                currentIndex={currentFileIndex}
                isOpen={previewOpen}
                onClose={handleClosePreview}
                onNavigate={handleNavigate}
            />
        </div>
    )
}